module.exports = __webpack_public_path__ + "images/6ef1432eaf980c7555fae8cca46c65bf-recomendaciones.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/webroot/_ui/responsive/common/js/src/assets/img/muestra/recomendaciones.jpg
// module id = 463
// module chunks = 13 15 19